import styled from '@emotion/styled';

export const Overlay = styled.div<{ isTransparent?: boolean }>`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: ${({ isTransparent }) => (isTransparent ? 'transparent' : 'rgba(255, 255, 255, 0.7)')};
  display: flex;
  justify-content: center;
  z-index: 10;
`;
